
import React from 'react';
import CommunityAboutPage from '@/components/cms/CommunityAboutPage';

const AboutUs = () => {
  return <CommunityAboutPage />;
};

export default AboutUs;
